import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import Viewer from "viewerjs";
import { changePictureSize } from "../../../../utils";
import "./style.scss";
// 滑块箭头
const Arrow = function (props) {
  const { className, onClick, iconName } = props;
  return (
    <div className={className} onClick={onClick}>
      <i className={`iconfont ${iconName}`} />
    </div>
  );
};

// eslint-disable-next-line max-params
const usePictureSlide = function ({ list = [], loading, num }) {
  const [active, setActive] = useState(0);
  const [viewer, setViewer] = useState(null);
  const slide1 = useRef();
  const slide2 = useRef();
  // slider 参数
  const settings1 = useMemo(
    () => ({
      slidesToShow: 1,
      dots: false,
      infinite: true,
      arrows: true,
      speed: 500,
      fade: true,
      slidesToScroll: 1,
      nextArrow: <Arrow iconName="icon-you" />,
      prevArrow: <Arrow iconName="icon-zuo" />,
      beforeChange: (current, next) => setActive(next),
    }),
    []
  );
  const v = useRef(null);
  // 点击
  const handleClick = useCallback(() => {
    viewer.view(active);
  }, [viewer, active]);
  useEffect(() => {
    if (!loading && list?.[0] && v.current) {
      if (!viewer || (viewer && viewer.images && viewer.images.length === 0)) {
        setViewer(
          new Viewer(v.current, {
            inline: false,
            url: "data-original",
            title: [4, (image) => `${image.alt} `],
          })
        );
      }
    }
    return () => {
      viewer && viewer.destroy();
    };
  }, [list, loading, viewer]);
  return (
    <div className="use-picture-slider-box">
      {list?.length > 1 ? (
        <Slider
          {...settings1}
          className="top-slider"
          ref={slide1}
          asNavFor={slide2?.current}
        >
          {list?.map((item, index) => {
            return (
              <div className="itembox" key={index}>
                <div className="mypicture">
                  <img src={changePictureSize(item.filePath, 600)} alt="" />
                </div>
                {item.content && <p>{item.content}</p>}
              </div>
            );
          })}
        </Slider>
      ) : (
        list?.map((item, index) => {
          return (
            <div className="itembox" key={index}>
              <div className="mypicture">
                <img src={item.filePath} alt="" />
              </div>
              {item.content && <p>{item.content}</p>}
            </div>
          );
        })
      )}

      <i className="fangda iconfont iconfangdajing" onClick={handleClick} />
      <div ref={v} style={{ display: "none" }}>
        {list[0]?.id &&
          list.map((item) => {
            const { id = "", title, filePath, content } = item;
            return (
              <img
                src={filePath}
                key={id}
                alt={content || title}
                data-original={filePath}
              />
            );
          })}
      </div>
    </div>
  );
};

export default usePictureSlide;
